<template>
  <div id="contenedor-ejecucion-default">
    <v-container fluid>
      <v-card class="mb-4" flat>
        <v-card-text>
          <titulo-tool-bar titulo="Estimaciones">
            <template v-slot:opciones-derecha>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    v-bind="attrs"
                    v-on="on"
                    @click="mostrarVentanaExcelEstimaciones = !mostrarVentanaExcelEstimaciones">
                    <v-icon> mdi-file-excel </v-icon>
                  </v-btn>
                </template>
                <span> Exportar Estimaciones </span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    v-bind="attrs"
                    v-on="on"
                    @click="abrirCalendarioActividades">
                    <v-icon> mdi-calendar-month </v-icon>
                  </v-btn>
                </template>
                <span> Ver Calendario de Pendientes </span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    v-bind="attrs"
                    v-on="on"
                    :to="{ name: 'contratosEstimacionesEstadisticas' }">
                    <v-icon>mdi-poll</v-icon>
                  </v-btn>
                </template>
                <span>Estadisticas</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    v-bind="attrs"
                    v-on="on"
                    :to="{ name: 'ejecuccionConfiguracionFirmas' }">
                    <v-icon>mdi-cog-outline</v-icon>
                  </v-btn>
                </template>
                <span>Configuracion</span>
              </v-tooltip>
            </template>
          </titulo-tool-bar>
          <tool-bar
            :filtros="filtros"
            :listaContratos="getContratos">
          </tool-bar>
        </v-card-text>
      </v-card>
      <v-card flat>
        <v-card-text>
          <!-- Loader -->
          <v-skeleton-loader
            v-if="$apollo.loading"
            type="table-heading, table-thead, table-tbody"
          ></v-skeleton-loader>
          <listado
            v-if="!$apollo.loading"
            :listadoContratos="getListadoDeContratos">
          </listado>
        </v-card-text>
      </v-card>
    </v-container>
    <v-dialog
      v-if="mostrarVentanaExcelEstimaciones"
      v-model="mostrarVentanaExcelEstimaciones"
      width="400">
      <excel-estimaciones-ejercicio
      :filtros="filtros"
      :contratos="getContratos"
      v-on:cerrar="mostrarVentanaExcelEstimaciones = !mostrarVentanaExcelEstimaciones">
      </excel-estimaciones-ejercicio>
    </v-dialog>
    <!-- Ventana Calendario de Pendientes de Contratos -->
    <v-dialog
      scrollable
      v-model="mostrarVentanaCalendarioActividades"
      :width="!$vuetify.breakpoint.mobile ? '80%' : '90%'">
      <v-card>
        <v-card-title class="secondary--text">
          Calendario de Pendientes de Contratos
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrarCalendarioActividades">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <!-- calendario de pendientes -->
          <calendario-actividades
          :listadoContratos="getContratos"
          :actividadesTodas="getActividadesTodas">
          </calendario-actividades>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrarCalendarioActividades"
            tipo="formCancelar"
            label="Cerrar"
            class="mr-3">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import CONTRATOS from '@/graphql/querys/administracion/contratos/contratosEstimaciones.gql';
import ACTIVIDADES_TODAS from '@/graphql/querys/administracion/actividades/actividadesTodas.gql';
import CalendarioActividades from '@/components/administracion/contratos/calendarioactividades/CalendarioActividades.vue';
import ExcelEstimacionesEjercicio from '@/components/exportar/exceles/ExcelEstimacionesEjercicio.vue';
import CustomButton from '@/components/buttons/Button.vue';
import TituloToolBar from '@/components/TituloToolBar.vue';
import ToolBar from './ToolBar.vue';
import Listado from './listado/Main.vue';

export default {
  name: 'EjecucionDefault',
  components: {
    ExcelEstimacionesEjercicio,
    CalendarioActividades,
    CustomButton,
    TituloToolBar,
    ToolBar,
    Listado,
  },
  data() {
    return {
      mostrarVentanaCalendarioActividades: false,
      mostrarVentanaExcelEstimaciones: false,
      filtros: {
        ejercicio: new Date().getFullYear(),
        buscarTexto: '',
        tipos: [],
        financiamiento: 'Todos',
        programas: [],
        contratistas: [],
        supervisores: [],
        guardarFiltros: false,
        tipoEstimacion: null,
      },
    };
  },
  mounted() {
    // Checar si hay filtros guardados.
    const filtrosGuardados = JSON.parse(this.mixGetFiltro('filtros-estimaciones'));
    if (filtrosGuardados) {
      this.filtros = JSON.parse(this.mixGetFiltro('filtros-estimaciones'));
    }
  },
  methods: {
    abrirCalendarioActividades() {
      this.mostrarVentanaCalendarioActividades = true;
    },
    cerrarCalendarioActividades() {
      this.mostrarVentanaCalendarioActividades = false;
    },
    setFiltros(filtros) {
      this.filtros = filtros;
    },
  },
  apollo: {
    contratos: {
      query: CONTRATOS,
    },
    actividadesTodas: {
      query: ACTIVIDADES_TODAS,
    },
  },
  computed: {
    getActividadesTodas() {
      if (!this.actividadesTodas) return [];
      return this.actividadesTodas;
    },
    getContratos() {
      if (!this.contratos) return [];
      return this.contratos// Separar el tipo de obra
        .map((contrato) => {
          const [obra] = contrato.obras;

          return {
            ...contrato,
            obra: obra || null,
          };
        });
    },
    getListadoDeContratos() {
      if (!this.contratos) return [];
      return this.contratos
        // Separar el tipo de obra
        .map((contrato) => {
          const [obra] = contrato.obras;

          return {
            ...contrato,
            obra: obra || null,
          };
        })
        .slice()
        // .sort((a, b) => new Date(b.fecha) - new Date(a.fecha))
        .sort((a, b) => a.orden - b.orden)
        // Filtrar por ejercicio
        .filter(({ ejercicio }) => ejercicio === this.filtros.ejercicio)
        // Por tipo de obra
        .filter(({ obra }) => {
          if (this.filtros.tipos.length <= 0) return true;
          if (obra === null && this.filtros.tipos.length > 0) return false;
          const idTipo = obra.obra.tipo.id;

          return this.filtros.tipos.includes(idTipo);
        })
        // Filtrar por tipo de contrato
        .filter(({ esObraFinanciada }) => {
          if (this.filtros.financiamiento === 'Todos') return true;

          if (this.filtros.financiamiento === 'Normal') return esObraFinanciada === false;

          return esObraFinanciada === true;
        })
        // Programa de obra
        .filter(({ obra }) => {
          if (this.filtros.programas.length <= 0) return true;
          if (obra === null && this.filtros.programas.length > 0) return false;
          const idPrograma = obra.obra.programa.id;

          return this.filtros.programas.includes(idPrograma);
        })
        // Filtro por contratista
        .filter(({ idContratista }) => {
          const { contratistas } = this.filtros;
          if (contratistas.length <= 0) return true;

          return contratistas.includes(idContratista);
        })
        // Filtro por supervisor
        .filter(({ responsables }) => {
          const responsablesaFiltrados = responsables.map(({ idFuncionario }) => idFuncionario);
          const { supervisores } = this.filtros;
          if (supervisores.length <= 0) return true;

          return supervisores.some((id) => responsablesaFiltrados.includes(id));
        })
        // Filtro por tipo de estimaciones
        .filter(({ estimaciones }) => {
          if (!this.filtros.tipoEstimacion) return true;

          if (this.filtros.tipoEstimacion === 1) {
            return estimaciones.some(
              ({ esEstimacionFiniquito }) => esEstimacionFiniquito === true,
            );
          }
          if (this.filtros.tipoEstimacion === 2) {
            if (estimaciones.length <= 0) return false;
            return estimaciones.every(
              ({ esEstimacionFiniquito }) => esEstimacionFiniquito === false,
            );
          }

          return estimaciones.length === 0;
        })
        .filter((contrato) => {
          if (!this.filtros.buscarTexto) return contrato;
          const expt = new RegExp(this.filtros.buscarTexto, 'gi');
          const numero = this.$normalizacionTexto(contrato.numero);
          const meta = this.$normalizacionTexto(contrato.meta);
          const contratista = this.$normalizacionTexto(
            contrato.contratista.nombreRazonSocial,
          );
          return (
            expt.test(numero)
            || expt.test(meta)
            || expt.test(contratista)
            || expt.test(contrato.numero)
            || expt.test(contrato.meta)
            || expt.test(contrato.contratista.nombreRazonSocial)
          );
        })
        .map((contrato) => ({
          ...contrato,
          cantidadEstimaciones: Number(contrato.estimaciones.length),
        }));
    },
  },
  watch: {
    filtros: {
      handler(filtros) {
        if (filtros.guardarFiltros) {
          this.mixGuardarFiltros('filtros-estimaciones', JSON.stringify(filtros));
        } else {
          this.mixRemoverFiltro('filtros-estimaciones');
        }
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss">
</style>
